export default __webpack_public_path__ + "static/media/48ac457aeb29f7530aa73440a18c2482.svg";